import React from "react";

import { Positions, Status } from "src/components/common";
import { useHeader } from "./hooks";

export const Header = () => {
  const { getHeaderProps, values } = useHeader();
  return (
    <div {...getHeaderProps()}>
      {values.game && <Positions game={values.game} />}
      {values.game && <Status game={values.game} />}
    </div>
  );
};
